export default __webpack_public_path__ + "static/media/georgia-flag.497b2e0d.png";